/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LicenseRenewal {
    Monthly = 0,
    Quarterly = 1,
    Annually = 2,
    Perpetual = 3,
}
